"use strict";

(async () => {
    const LOG_PREFIX = "[Blockly System]";
    const BASE_PATH = "./assets/blockly/";

    /**
     * Sequence critical: 
     * Generator -> Core (Hooks/Context/Workspace) -> Blocks
     */
    const DEPENDENCIES = [
        "generators/arduino.generator.js",
        "core/index.js",
        "blocks/index.js",
    ];

    async function loadAll() {
        console.log(`${LOG_PREFIX} Initializing...`);
        for (const path of DEPENDENCIES) {
            console.log(BASE_PATH,path);
            await import(`${BASE_PATH}${path}`);
        }
        console.log(`${LOG_PREFIX} Ready`);
    }

    window.__blocklyLoaded = loadAll().catch((err) => {
        console.error(`${LOG_PREFIX} Failed:`, err?.message ?? err);
        throw err;
    });
})();
